import {
  TextInput,
  SelectInput,
  ReferenceInput,
  ReferenceArrayInput,
  SelectArrayInput,
  NumberInput,
} from "react-admin";
import { roleLabel } from "../../util/roleLabel";

export const postFilters = [
  <TextInput label="Nome / E-mail / CPF" source="mailName" alwaysOn />,
  <SelectInput
    source="hasRegistrationNumber"
    label="Possui Matrícula"
    emptyText="Todos"
    // defaultValue={"true"}
    choices={[
      { id: "true", name: "Sim" },
      { id: "false", name: "Não" },
    ]}
    alwaysOn={"true"}
  />,
  <NumberInput label="Matrícula (sem dígito)" source="registrationNumber" />,
  <TextInput label="Endereço (Cidade, rua, cep...)" source="addressQuery" />,

  // <DateInput source="effectiveDate" label="Data Efetivo de" />,
  <ReferenceArrayInput
    source="technicalDivisions"
    label="Divisões Técnicas"
    reference="technical-divisions/crud">
    <SelectArrayInput label="Divisões Técnicas" />
  </ReferenceArrayInput>,
  <TextInput label="Formação" source="userGraduationQuery" />,
  <TextInput label="Atividade Profissional" source="professionalActivity" />,

  <TextInput
    label="Instituição de Ensino"
    source="userEducationalInstituteQuery"
  />,
  <ReferenceInput
    label="Categoria"
    source="userCategoryId"
    reference="user-categories/crud">
    <SelectArrayInput label="Categoria de Membro" optionText="name" />
  </ReferenceInput>,
  <TextInput label="Nº CREA" source="CREA" />,
  <SelectInput
    source="hasCREA"
    label="Possui CREA"
    emptyText="Todos"
    choices={[
      { id: "true", name: "Sim" },
      { id: "false", name: "Não" },
    ]}
  />,
  // Pedido do cliente (04/08): filtrar quem tem transações registradas.
  // Servidor trata via filtro de relação (hasTransactions) — as 71
  // transações órfãs (sem sócio vinculado) não contam para ninguém.
  <SelectInput
    source="hasTransactions"
    label="Tem Transações"
    emptyText="Todos"
    choices={[
      { id: "true", name: "Sim" },
      { id: "false", name: "Não" },
    ]}
  />,
  <SelectArrayInput
    source="accountStatus"
    label="Situação"
    choices={[
      { id: "ACTIVE", name: "Ativo" },
      { id: "CANCELED", name: "Cancelado" },
      { id: "NO_CONTACT", name: "Sem contato" },
      { id: "LICENSED", name: "Licenciado" },
      { id: "DECEASED", name: "Falecido" },
      { id: "UNKNOWN", name: "Desconhecido" },
      { id: "PENDING", name: "Pendente" },
    ]}
  />,
  <SelectInput
    source="hasPhysicalCard"
    label="Possui Carteirinha"
    emptyText="Todos"
    choices={[
      { id: "true", name: "Sim" },
      { id: "false", name: "Não" },
    ]}
  />,
  <SelectInput
    source="gender"
    label="Sexo"
    emptyText="Todos"
    choices={[
      { id: "M", name: "Masculino" },
      { id: "F", name: "Feminino" },
    ]}
  />,
  <SelectInput
    source="maritalStatus"
    label="Estado Civil"
    emptyText="Todos"
    choices={[
      { id: "SOLTEIRO", name: "Solteiro(a)" },
      { id: "CASADO", name: "Casado(a)" },
      { id: "DESQUITADO", name: "Desquitado(a)" },
      { id: "DIVORCIADO", name: "Divorciado(a)" },
      { id: "VIUVO", name: "Viúvo(a)" },
      { id: "UNIAO_ESTAVEL", name: "União Estável" },
    ]}
  />,
  <ReferenceInput
    label="Regra de Usuário"
    source="roleId"
    reference="user-roles/crud">
    <SelectInput
      label="Regra de Usuário"
      optionText={(r: any) => roleLabel(r?.name)}
      emptyText="Todas"
    />
  </ReferenceInput>,
  <SelectInput
    source="subscriptionStatus"
    label="Status Assinatura IUGU"
    emptyText="Todos"
    choices={[
      { id: "active", name: "Adimplente" },
      { id: "due", name: "Inadimplente" },
      { id: "suspended", name: "Suspensa" },
    ]}
  />,
  <SelectInput
    source="userEnabled"
    label="Adimplência (Regra Customizada)"
    emptyText="Todos"
    title="A lista de membros adimplentes/inadimplentes atualizam em
    background a cada 3 minutos e armazenadas em cache, alterações
    que afetem adimplência podem levar até 3 min para surtir
    efeito na visualização desta lista de Sócios. (Este cache não
    afeta exportação de membros, mediante a exportação os dados
    são solicitados em tempo real.)"
    choices={[
      { id: "true", name: "Adimplente" },
      { id: "false", name: "Inadimplente" },
    ]}
  />,
  <TextInput label="Última Contribuição" source="userLastContribution" />,
  <SelectInput
    label="Aniversariantes do Mês"
    source="birthMonth"
    emptyText="Todos"
    choices={[
      { id: "1", name: "Janeiro" },
      { id: "2", name: "Fevereiro" },
      { id: "3", name: "Março" },
      { id: "4", name: "Abril" },
      { id: "5", name: "Maio" },
      { id: "6", name: "Junho" },
      { id: "7", name: "Julho" },
      { id: "8", name: "Agosto" },
      { id: "9", name: "Setembro" },
      { id: "10", name: "Outubro" },
      { id: "11", name: "Novembro" },
      { id: "12", name: "Dezembro" },
    ]}
  />,
];
